import MediaList from "./Settings/Media/MediaList";
import MediaService from "@/services/MediaService";

export default {
  namespaced: true,
  state: () => ({
    acceptFiles: [],
    acceptFilesList: [],
    acceptBaseImages: [],
    mediaListTypes: {},
    mediaFormats: {},
  }),
  getters: {
    isBaseImage: (state) => (type) => {
      return state.acceptBaseImages.includes(type);
    },
  },
  mutations: {
    setAcceptFiles: (state, data) => {
      state.acceptFiles = data;
    },
    setAcceptFilesList: (state, data) => {
      state.acceptFilesList = data;
    },
    setAcceptBaseImages: (state, data) => {
      state.acceptBaseImages = data;
    },
    setMediaListTypes: (state, data) => {
      state.mediaListTypes = data;
    },
    setMediaFormats: (state, data) => {
      state.mediaFormats = data;
    },
  },
  actions: {
    getAcceptFiles: ({ commit }) => {
      return new Promise((resolve, reject) => {
        MediaService.acceptFiles()
          .then((res) => {
            if (res.status === 200) {
              commit("setAcceptFiles", res.data);
              resolve(res);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getAcceptFilesList: ({ commit }) => {
      return new Promise((resolve, reject) => {
        MediaService.acceptFilesList()
          .then((res) => {
            if (res.status === 200) {
              commit("setAcceptFilesList", res.data);
              resolve(res);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getAcceptBaseImages: ({ commit }) => {
      return new Promise((resolve, reject) => {
        MediaService.acceptBaseImages()
          .then((res) => {
            if (res.status === 200) {
              commit("setAcceptBaseImages", res.data);
              resolve(res);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getMediaListTypes: ({ commit }) => {
      return new Promise((resolve, reject) => {
        MediaService.mediaListTypes()
          .then((res) => {
            if (res.status === 200) {
              commit("setMediaListTypes", res.data);
              resolve(res);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getMediaFormats: ({ commit }) => {
      return new Promise((resolve, reject) => {
        MediaService.mediaFormats()
          .then((res) => {
            if (res.status === 200) {
              commit("setMediaFormats", res.data);
              resolve(res);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  modules: {
    MediaList,
  },
};
